import type { TFunction } from 'i18next'

/**
 * "hozirgina" / "42 s oldin" / "3 daq oldin" — jadval ustunlari uchun.
 *
 * NEGA ANIQ VAQT YETARLI EMAS: `acctupdatetime` ustuni operatorga bitta
 * savol uchun kerak — "bu sessiya hali TIRIKMI". Unga javob berish uchun
 * "19:04:39" ni ko'rib, hozirgi soatni topib, ayirish kerak bo'ladi.
 * "2 daq oldin" esa javobning o'zi. Aniq vaqt yo'qolmaydi — u tooltip'da
 * qoladi (`utcTooltip`), chunki shubha tug'ilganda ASL qiymat kerak.
 *
 * ⚠️ SOATLAR VA KUNLAR HAM SANALADI. `RefreshIndicator` dagi ichki
 * o'xshash funksiya faqat soniya va daqiqani biladi va bu O'SHA YERDA
 * to'g'ri: u 15 sekundlik davrni ko'rsatadi, ya'ni qiymat hech qachon
 * bir necha daqiqadan oshmaydi. Bu yerda esa aksincha — osilib qolgan
 * sessiyada oxirgi yangilanish soatlab, hatto kunlab oldin bo'lishi
 * mumkin va "3120 daq oldin" o'qib bo'lmaydigan raqam bo'lardi.
 *
 * `units.duration.*` va `refresh.*` kalitlari QAYTA ISHLATILADI — uch
 * tilda yangi tarjima qo'shilmasin.
 */
export function relativeFromNow(iso: string | null | undefined, t: TFunction): string {
  if (!iso) return '—'
  const at = new Date(iso).getTime()
  if (Number.isNaN(at)) return '—'

  // Kelajakdagi vaqt (soatlar mos kelmasa bo'lishi mumkin) manfiy sanoq
  // bermasin — u "-5 daq oldin" kabi bema'ni matnga aylanardi
  const sec = Math.max(0, Math.round((Date.now() - at) / 1000))

  if (sec < 5) return t('refresh.justNow')
  if (sec < 60) return t('refresh.secondsAgo', { count: sec })
  if (sec < 3600) return t('refresh.minutesAgo', { count: Math.floor(sec / 60) })
  if (sec < 86400) return t('refresh.hoursAgo', { count: Math.floor(sec / 3600) })
  return t('refresh.daysAgo', { count: Math.floor(sec / 86400) })
}
